// Cookie names
export enum CookieName {
  FlowstepCookiesConsent = "flowstep_cookies_consent",
  FlowstepMixpanel = "flowstep_mixpanel",
  FlowstepAttribution = "flowstep_attribution",
}

export const FLOWSTEP_COOKIE_EXPIRATION_IN_DAYS: number = 365; // 1 year
export const FLOWSTEP_COOKIE_EXPIRATION_IN_SECONDS: number =
  FLOWSTEP_COOKIE_EXPIRATION_IN_DAYS * 24 * 60 * 60; // 1 year
